/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react'
import ElementContainer from '../ElementContainer'
import {
  Button,
  Input,
  Typography
} from '@mui/material'
import { signatureElementStyles } from '../../../styles/classes/MobilePreviewClasses'
import { useTranslation } from 'react-i18next'

const SignatureElement = ({
  title,
  helpfulHint,
  answer,
  onChangeValue,
  isMandatory,
  isPreviewMode,
  disabled
}) => {
  const [localTitle, setLocalTitle] = useState(answer?.title)
  const { classes } = signatureElementStyles()
  const { t } = useTranslation()
  const [localImage, setLocalImage] = useState(answer?.url)

  const imageChangeHandler = e => {
    const files = [...e.target.files]
    const file = files[0]
    const imageUrl = URL.createObjectURL(file)
    onChangeValue({ ...answer, url: imageUrl })
    setLocalImage(imageUrl)
  }

  const titleChangeHandler = e => {
    setLocalTitle(e.target.value)
  }

  const blurHandler = () => {
    onChangeValue({ ...answer, title: localTitle })
  }

  const inputImage = () => {
    return (
      <input
        hidden
        accept="image/png, image/jpeg, image/jpg, image/bitmap"
        type="file"
        onChange={imageChangeHandler}
      />
    )
  }

  return (
    <ElementContainer
      title={title}
      helpfulHint={helpfulHint}
      isMandatory={isMandatory}
    >
      {!localImage && (
        <Button
          fullWidth
          component="label"
          className={classes.placeholderContainer}
          disabled={disabled}
        >
          {inputImage()}
          <Typography className={classes.placeholderText}>
            {t('mobile_preview.signature.sign_here')}
          </Typography>
        </Button>
      )}
      {localImage && (
        <Button fullWidth component="label">
          {inputImage()}
          <img
            className={classes.signatureImage}
            src={localImage}
            srcSet={localImage}
            loading="lazy"
          />
        </Button>
      )}
      <Input
        disabled={disabled}
        fullWidth
        className={classes.textInput}
        size="small"
        disableUnderline
        onBlur={blurHandler}
        onChange={titleChangeHandler}
        value={localTitle}
        placeholder={t('mobile_preview.signature.enter_name_here')}
      />
    </ElementContainer>
  )
}

export default SignatureElement
